/* eslint-disable no-sparse-arrays */
import { get } from 'styled-system';

const normalizeHex = (hex) => {
  let hexNumber = hex.replace(/^#/, '');
  if (hexNumber.length === 3) {
    const [r, g, b] = hexNumber;
    hexNumber = r + r + g + g + b + b;
  }
  return hexNumber;
};

const hexToRGB = (hex) => {
  const hexNumber = normalizeHex(hex);
  const [, ...splitedHex] = /^([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(
    hexNumber
  ) || [, '0', '0', '0'];
  const [red, green, blue] = splitedHex.map((hex) => parseInt(hex, 16));
  return {
    red,
    green,
    blue,
  };
};

export const rgba = (colorToken, alpha) => (theme) => {
  const { red, green, blue } = hexToRGB(get(theme.colors, colorToken));
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};

export const darken = (colorToken, ratio) => (theme) => {
  const { red, green, blue } = hexToRGB(get(theme.colors, colorToken));
  const darkenRatio = 1 - ratio;
  return `rgba(${red * darkenRatio}, ${green * darkenRatio}, ${
    blue * darkenRatio
  })`;
};
